export enum PaymentActionStateEnum {
  NOTIFY_VENDORS = 'notify_vendors',
  PAYMENT_SCHEDULED = 'payment_scheduled',
  EXTERNAL_PAYMENT_SCHEDULED = 'external_payment_scheduled',
  AUTO_PAY_CAPABLE_PAYMENT_SCHEDULED = 'auto_pay_capable_payment_scheduled',
  EBILL_CAPABLE_PAYMENT_SCHEDULED = 'ebill_capable_payment_scheduled',
}
